<template>
  <div>
    <div @click="seeOther" :class="['other-options']" v-if="formItem.options && formItem.options.length">
      <div class="banner-desc">
        <h3 v-if="formItem.title">{{ formItem.title }}</h3>
        <p v-if="formItem.sub_title">{{ formItem.sub_title }}</p>
      </div>
      <span :class="['unOpen', { opened: isOpened }]"></span>
    </div>
    <div class="option-container" v-show="isOpened">
        <div class="option" v-for="(item, idx) in formItem.options" :key="idx">
            <component
              :is="getCom(item)"
              :form-item="item"
              :idx="idx"
              @form-update="formUpdate"
              :cm="true"
              :is_finished="is_finished"
              :is_ocr="is_ocr"
              :page_type="page_type"
              :page_style="page_style"
              :can-upload="canUpload"
            ></component>
        </div>
    </div>
  </div>
</template>
<script>
import UploadSelect from "../base/upload-select";

export default {
  name: "typeCard",
  props: ["formItem", "idx", "is_ocr", "page_style", "page_type", "is_finished", "canUpload"],
  data() {
    return {
      isOpened: false,
    };
  },
  mounted() {
    const other_audit_is_expand = window.localStorage && window.localStorage.getItem("other_audit_is_expand");
    if (['true', 'false'].includes(other_audit_is_expand)) {
      this.isOpened = other_audit_is_expand === 'true'
    } else {
      this.isOpened = this.formItem.is_expand
    }
  },
  components: {
    UploadSelect,
  },
  computed: {
    // isChecked() {
    //   return this.choosedKey === this.formItem.key;
    // },
  },
  methods: {
    getCom(item) {
      return {
        photo: UploadSelect,
        portrait: UploadSelect,
        declare: UploadSelect,
        color: UploadSelect,
        "linkage-photo": UploadSelect,
        "link-photo": UploadSelect,
        "multi-photo": UploadSelect,
        "multi-declare": UploadSelect,
        "introduce": UploadSelect,
        "select-photo": UploadSelect,
        "inner-input": UploadSelect,
        "in_select_photo": UploadSelect,
        "photo_new": UploadSelect,
        "photo_simplify": UploadSelect,
        "bank-card-99": UploadSelect,
      }[item.type];
    },
    formUpdate() {

    },
    seeOther() {
      this.isOpened = !this.isOpened;
      window.localStorage && window.localStorage.setItem("other_audit_is_expand", this.isOpened);
    },
    chooseWork(item) {
      this.$emit("choose", item);
    },
  },
};
</script>
<style lang="scss" scoped>
.other-options {
  position: relative;
  display: flex;
  align-items: center;
  margin: 0.83rem 0 0.16rem 0;
  padding: 0 0.32rem;
  min-height: 0.84rem;
  .banner-desc {
    padding-right: 0.49rem;
  }
  .banner-desc > h3 {
    font-size: 0.36rem;
    color: #333333;
    line-height: 0.42rem;
    font-weight: 500;
  }
  .banner-desc > p {
    font-size: 0.24rem;
    color: #999999;
    line-height: 0.42rem;
    font-weight: 400;
  }
  .unOpen {
    position: absolute;
    top: 50%;
    right: 0.32rem;
    width: 0.48rem;
    height: 0.48rem;
    background: url("../../images/arrow_show_hide.png") no-repeat;
    background-size: 100%;
    transform: translateY(-50%);
  }
  .opened {
    transform: translateY(-50%) rotate(180deg);
  }
}
</style>


